import { MenuWrapper } from './components/MenuWrapper';

import type { MenuProps } from '@mui/material/Menu';
import type { FC } from 'react';

export const MENU_TEST_ID = 'menu';

export const Menu: FC<MenuProps> = ({ children, ...props }) => (
  <MenuWrapper
    data-testid={MENU_TEST_ID}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  >
    {children}
  </MenuWrapper>
);
